import react from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";

const ChangePasswordAlertModal = () => {
    const navigate = useNavigate();
    const handleClose = () => {
        navigate('/change-password');
    };

    return (
        <>
        <style>
        {`
        .modal-backdrop {
            width: 100% !important;
            height: 100% !important;
        }
        `}
    </style>
        {/* <div className="modal-backdrop fade show w-100 h-100"></div> */}
        <Modal show={true} onHide={handleClose} backdrop="static" keyboard={false} centered dialogClassName="force-top-modal">
            <Modal.Header>
                <Modal.Title>Password Change Required</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                For security reasons, you are required to change your password before proceeding.
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={handleClose}>
                    Change Password
                </Button>
            </Modal.Footer>
        </Modal>
        </>
        
    );
}
export default ChangePasswordAlertModal;